import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import {
	CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT,
	CREATION_FOCUSED_NAV_START_TIME,
} from '../../constants/onboarding-state/onboarding-constants';
import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadSideNavigationOnboardingState = (): Promise<{
	data: unknown;
	hasErrors: boolean;
}> => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT, CREATION_FOCUSED_NAV_START_TIME],
		},
	});
};
